import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  apiInsurerApiAll: [],
  apiInsurerApi: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const apiInsurerApiSlice = createSlice({
  name: "apiInsurerApi",
  initialState,
  reducers: {
    setApiInsurerApiAll: (state, action) => {
      state.apiInsurerApiAll = action.payload;
    },
    setApiInsurerApi: (state, action) => {
      state.apiInsurerApi = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setApiInsurerApiAll,
  setApiInsurerApi,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = apiInsurerApiSlice.actions;

export default apiInsurerApiSlice.reducer;
